import * as Yup from "yup";
import { Validator } from "../../../shared/constants/validator";

type TranslateFunction = (key: string) => string;

export const createRegisterValidationSchema = (
    t: TranslateFunction
) =>
    Yup.object({
        firstName: Yup.string()
            .trim()
            .min(
                Validator.minLengthName,
                t("registerForm.INVALID_FIRST_NAME")
            )
            .max(
                Validator.maxLengthName,
                t("registerForm.INVALID_FIRST_NAME")
            )
            .matches(
                Validator.nameRegExp,
                t("registerForm.INVALID_FIRST_NAME")
            )
            .required(
                t("registerForm.REQUIRED_FIRST_NAME")
            ),

        lastName: Yup.string()
            .trim()
            .min(
                Validator.minLengthName,
                t("registerForm.INVALID_LAST_NAME")
            )
            .max(
                Validator.maxLengthName,
                t("registerForm.INVALID_LAST_NAME")
            )
            .matches(
                Validator.nameRegExp,
                t("registerForm.INVALID_LAST_NAME")
            )
            .required(
                t("registerForm.REQUIRED_LAST_NAME")
            ),

        email: Yup.string()
            .trim()
            .email(
                t("registerForm.INVALID_EMAIL")
            )
            .max(
                255,
                t("registerForm.INVALID_EMAIL")
            )
            .required(
                t("registerForm.REQUIRED_EMAIL")
            ),

        phone: Yup.string()
            .trim()
            .matches(
                Validator.phoneNumberRegExp,
                t("registerForm.INVALID_PHONE")
            )
            .required(
                t("registerForm.REQUIRED_PHONE")
            ),

        language: Yup.string()
            .required(
                t("registerForm.REQUIRED_LANGUAGE")
            ),

        companyName: Yup.string()
            .trim()
            .min(
                Validator.minLengthName,
                t("registerForm.INVALID_COMPANY_NAME")
            )
            .max(
                255,
                t("registerForm.INVALID_COMPANY_NAME")
            )
            .required(
                t("registerForm.REQUIRED_COMPANY_NAME")
            ),

        vatNumber: Yup.string()
            .trim()
            .matches(
                Validator.vatNumberExp,
                t("registerForm.INVALID_VAT_NUMBER")
            )
            .required(
                t("registerForm.REQUIRED_VAT_NUMBER")
        ),

        streetName: Yup.string()
            .trim()
            .max(
                255,
                t("registerForm.INVALID_STREET")
            )
            .required(
                t("registerForm.REQUIRED_STREET")
            ),

        buildingNumber: Yup.string()
            .trim()
            .max(
                20,
                t("registerForm.INVALID_BUILDING_NUMBER")
            )
            .required(
                t("registerForm.REQUIRED_BUILDING_NUMBER")
            ),

        flatNumber: Yup.string()
            .trim()
            .max(
                20,
                t("registerForm.INVALID_FLAT_NUMBER")
            ),

        postalCode: Yup.string()
            .trim()
            .max(
                20,
                t("registerForm.INVALID_POSTAL_CODE")
            )
            .required(
                t("registerForm.REQUIRED_POSTAL_CODE")
            ),

        city: Yup.string()
            .trim()
            .max(
                150,
                t("registerForm.INVALID_CITY")
            )
            .required(
                t("registerForm.REQUIRED_CITY")
            ),

        country: Yup.string()
            .required(
                t("registerForm.REQUIRED_COUNTRY")
        ),

        password: Yup.string()
            .min(
                8,
                t("registerForm.PASSWORD_MIN_LENGTH")
            )
            .matches(
                /[A-Z]/,
                t("registerForm.PASSWORD_UPPERCASE")
            )
            .matches(
                /[a-z]/,
                t("registerForm.PASSWORD_LOWERCASE")
            )
            .matches(
                /\d/,
                t("registerForm.PASSWORD_NUMBER")
            )
            .required(
                t("registerForm.REQUIRED_PASSWORD")
            ),

        passwordConfirmation: Yup.string()
            .oneOf(
                [Yup.ref("password")],
                t("registerForm.PASSWORDS_NOT_MATCH")
            )
            .required(
                t(
                    "registerForm.REQUIRED_PASSWORD_CONFIRMATION"
                )
            ),

        termsAccepted: Yup.boolean()
            .oneOf(
                [true],
                t("registerForm.REQUIRED_TERMS")
            )
    });